"use strict";

exports.__esModule = true;
exports.default = identity;

function identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/identity.js
// module id = 225
// module chunks = 0